function createCircle() {
  const circle = document.createElement('div');
  circle.classList.add('circle');
  circle.style.width = circle.style.height = `${Math.random() * 100 + 20}px`; // 随机大小 10px 到 30px
  circle.style.backgroundColor = ['#275183', '#fabf13', '#29d1c9'][Math.floor(Math.random() * 3)];
  circle.style.left = `${Math.random() * 100}%`;
  circle.style.top = `${Math.random() * 100}%`;
  document.querySelector('.floatingCircles').appendChild(circle);
  moveCircle(circle);
}

function moveCircle(circle) {
  setInterval(() => {
    const newTop = parseInt(circle.style.top) + (Math.random() > 0.5 ? -20 : 20);
    circle.style.top = `${Math.max(0, Math.min(100, newTop))}%`;
  }, 5000);
}

// 生成 50 个圆点
for (let i = 0; i < 15; i++) {
  createCircle();
}
